<template>
  <v-dialog
    v-model="dialog"
    width="360px">
    <div class="dialog-container">
      <h2>Add Remark</h2>
      <div class="form-item">
        <span>Content</span>
        <v-input
          v-model="content"
          type="textarea"
          :rows="4" />
      </div>
      <div class="form-item">
        <file-container
          :edit="true"
          :fileData="remark_file"
          @delete="handlerDeleteFile"
          @uploadSuccess="handlerUploadSuccess" />
      </div>
      <div class="dialog-footer">
        <div>
          <v-button @click="dialog = false">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerSend">Save</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'AddRemark',
  data() {
    return {
      dialog: false,
      content: '',
      remark_file: null
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    initData() {
      this.content = ''
      this.remark_file = null
      this.dialog = false
    },
    handlerSend() {
      if(this.content) {
        this.$emit('confirm', {
          content: this.content,
          remark_file: this.remark_file
        })
      }
    },
    handlerDeleteFile() {
      this.remark_file = null
    },
    handlerUploadSuccess({ data }) {
      this.remark_file = data
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    .el-checkbox {
      margin: 10px 0;
    }
    p {
      padding-bottom: 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
  }
</style>